export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-little-4.d5cb84f7.svg";